module.exports = __webpack_public_path__ + "img/logo_kraum.95c6ce3c.png";